(ns bec-cljs-common.utils.touch
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [clojure.string :as s]))

(defonce touch-variables (r/atom {}))

;; -- Touch events ----------------------------------------------------------------

(defn swipe-horizontal-decay []
  (let [swipe-decay-amount (-> @touch-variables :options :swipe-decay-amount)
        on-handle-swipe-decay (-> @touch-variables :options :on-handle-swipe-decay)
        normalized-relative-x (-> @touch-variables :handler :normalized-relative-x)
        normalized-velocity-x (* swipe-decay-amount (-> @touch-variables :handler :normalized-velocity-x))
        updated-normalized-relative-x (+ normalized-relative-x normalized-velocity-x)
        updated-swipe-decay {:normalized-relative-x updated-normalized-relative-x}]
    (swap! touch-variables assoc :swipe-decay updated-swipe-decay)
    (when (fn? on-handle-swipe-decay)
      (on-handle-swipe-decay @touch-variables))))

(defn handle-horizontal-touch []
  (let [min-distance-threshold (-> @touch-variables :options :min-distance-threshold)
        min-time-threshold (-> @touch-variables :options :min-time-threshold)
        swipe-decay-active? (-> @touch-variables :options :swipe-decay-active?)
        reset-position-on-swipe-direction-change? (-> @touch-variables :options
                                                    :reset-position-on-swipe-direction-change?)
        on-handle-touch (-> @touch-variables :options :on-handle-touch)
        on-tap (-> @touch-variables :options :on-tap)
        start-x (-> @touch-variables :start :x)
        move-x (or (-> @touch-variables :move :x) start-x)
        relative-x (- move-x start-x)                    ;;Negative to the left, positive to the right
        prev-move-x (or (-> @touch-variables :prev-move :x) start-x)
        previous-swipe-direction (-> @touch-variables :handler :current-swipe-direction-x)
        current-swipe-direction (> move-x prev-move-x)
        prev-relative-x (- prev-move-x start-x)
        start-time (-> @touch-variables :start :time)
        end-time (-> @touch-variables :end :time)
        move-time (-> @touch-variables :move :time)
        prev-move-time (-> @touch-variables :prev-move :time)
        swipe-duration (when (and start-time end-time) (- end-time start-time))
        last-swipe-duration (when (and prev-move-time move-time) (- prev-move-time move-time))
        velocity-x (when last-swipe-duration (/ (- relative-x prev-relative-x) last-swipe-duration))
        viewport-width (or (-> @touch-variables :options :viewport-width)
                         (-> @touch-variables :handler :viewport-width)
                         (. js/window -innerWidth)
                         (. (. js/document -documentElement) -clientWidth)
                         (. (. js/document -body) -clientWidth))
        normalized-relative-x (/ relative-x viewport-width)
        normalized-velocity-x (/ velocity-x viewport-width)
        scaled-normalized-relative-x (if (> normalized-relative-x 0)
                                       (- normalized-relative-x (Math/floor normalized-relative-x))
                                       (- normalized-relative-x (Math/ceil normalized-relative-x)))
        prev-scaled-normalized-relative-x (-> @touch-variables :handler :scaled-normalized-relative-x)
        handler {:previous-swipe-direction-x previous-swipe-direction
                 :current-swipe-direction-x current-swipe-direction
                 :previous-relative-x prev-relative-x
                 :relative-x relative-x
                 :swipe-duration swipe-duration
                 :last-swipe-duration last-swipe-duration
                 :velocity-x velocity-x
                 :viewport-width viewport-width
                 :normalized-relative-x normalized-relative-x
                 :normalized-velocity-x normalized-velocity-x
                 :scaled-normalized-relative-x scaled-normalized-relative-x
                 :prev-scaled-normalized-relative-x prev-scaled-normalized-relative-x}]
    ;; When changing swipe direction, we set the new start position
    (when (and (not (false? reset-position-on-swipe-direction-change?))
            (not (nil? previous-swipe-direction))
            (not (= previous-swipe-direction current-swipe-direction)))
      (swap! touch-variables #(assoc-in % [:start :x] move-x)))

    (swap! touch-variables assoc :handler handler)
    (if (and (fn? on-tap)
          swipe-duration
          (< swipe-duration min-time-threshold)
          (< (Math/abs relative-x) min-distance-threshold))
      (on-tap @touch-variables)
      (when (fn? on-handle-touch)
        (on-handle-touch @touch-variables)))
    (when (and end-time swipe-decay-active?)
      (swipe-horizontal-decay))))

(defn handle-simple-horizontal-touch []
  (let [start-x (-> @touch-variables :start :x)
        move-x (or (-> @touch-variables :move :x) start-x)
        prev-move-x (or (-> @touch-variables :prev-move :x) start-x)]
    (when (> (Math/abs (- prev-move-x move-x)) 1)
      (let [min-distance-threshold (-> @touch-variables :options :min-distance-threshold)
           min-time-threshold (-> @touch-variables :options :min-time-threshold)
           on-handle-touch (-> @touch-variables :options :on-handle-touch)
           on-tap (-> @touch-variables :options :on-tap)
           relative-x (- move-x start-x)                    ;;Negative to the left, positive to the right
           previous-swipe-direction (-> @touch-variables :handler :current-swipe-direction-x)
           current-swipe-direction (> move-x prev-move-x)
           start-time (-> @touch-variables :start :time)
           end-time (-> @touch-variables :end :time)
           move-time (-> @touch-variables :move :time)
           prev-move-time (-> @touch-variables :prev-move :time)
           swipe-duration (when (and start-time end-time) (- end-time start-time))
           last-swipe-duration (when (and prev-move-time move-time) (- prev-move-time move-time))
           handler {:previous-swipe-direction-x previous-swipe-direction
                    :current-swipe-direction-x current-swipe-direction
                    :relative-x relative-x
                    :swipe-duration swipe-duration
                    :last-swipe-duration last-swipe-duration}]
       ;; When changing swipe direction, we set the new start position
       (when (and (not (nil? previous-swipe-direction))
               (not (= previous-swipe-direction current-swipe-direction)))
         (swap! touch-variables #(assoc-in % [:start :x] move-x)))

       (swap! touch-variables assoc :handler handler)
       (if (and (fn? on-tap)
             swipe-duration
             (< swipe-duration min-time-threshold)
             (< (Math/abs relative-x) min-distance-threshold))
         (on-tap @touch-variables)
         (when (fn? on-handle-touch)
           (on-handle-touch @touch-variables)))))))

(defn swipe-vertical-decay []
  (let [swipe-decay-amount (-> @touch-variables :options :swipe-decay-amount)
        on-handle-swipe-decay (-> @touch-variables :options :on-handle-swipe-decay)
        normalized-relative-y (-> @touch-variables :handler :normalized-relative-y)
        normalized-velocity-y (* swipe-decay-amount (-> @touch-variables :handler :normalized-velocity-y))
        updated-normalized-relative-y (+ normalized-relative-y normalized-velocity-y)
        updated-swipe-decay {:normalized-relative-y updated-normalized-relative-y}]
    (swap! touch-variables assoc :swipe-decay updated-swipe-decay)
    (when (fn? on-handle-swipe-decay)
      (on-handle-swipe-decay @touch-variables))))

(defn handle-simple-vertical-touch []
  (let [start-y (-> @touch-variables :start :y)
        move-y (or (-> @touch-variables :move :y) start-y)
        prev-move-y (or (-> @touch-variables :prev-move :y) start-y)]
    (when (> (Math/abs (- prev-move-y move-y)) 1)
      (let [min-distance-threshold (-> @touch-variables :options :min-distance-threshold)
            min-time-threshold (-> @touch-variables :options :min-time-threshold)
            reset-position-on-swipe-direction-change? (-> @touch-variables :options
                                                        :reset-position-on-swipe-direction-change?)
            on-handle-touch (-> @touch-variables :options :on-handle-touch)
            on-tap (-> @touch-variables :options :on-tap)
            previous-swipe-direction (-> @touch-variables :handler :current-swipe-direction-y)
            current-swipe-direction (> move-y prev-move-y)
            relative-y (when move-y (- move-y start-y))     ;;Negative upward, positive downward
            start-time (-> @touch-variables :start :time)
            end-time (-> @touch-variables :end :time)
            move-time (-> @touch-variables :move :time)
            prev-move-time (-> @touch-variables :prev-move :time)
            swipe-duration (when (and start-time end-time) (- end-time start-time))
            last-swipe-duration (when (and prev-move-time move-time) (- prev-move-time move-time))
            handler {:previous-swipe-direction-y previous-swipe-direction
                     :current-swipe-direction-y current-swipe-direction
                     :relative-y relative-y
                     :swipe-duration swipe-duration
                     :last-swipe-duration last-swipe-duration}]
        ;; When changing swipe direction, we set the new start position
        (when (and (not (false? reset-position-on-swipe-direction-change?))
                (not (nil? previous-swipe-direction))
                (not (= previous-swipe-direction current-swipe-direction)))
          (swap! touch-variables #(assoc-in % [:start :y] move-y)))

        (swap! touch-variables assoc :handler handler)
        (if (and on-tap
              swipe-duration
              (< swipe-duration min-time-threshold)
              (< (Math/abs relative-y) min-distance-threshold))
          (on-tap @touch-variables)
          (when (fn? on-handle-touch)
            (on-handle-touch @touch-variables)))))))

(defn handle-vertical-touch []
  (let [min-distance-threshold (-> @touch-variables :options :min-distance-threshold)
        min-time-threshold (-> @touch-variables :options :min-time-threshold)
        swipe-decay-active? (-> @touch-variables :options :swipe-decay-active?)
        reset-position-on-swipe-direction-change? (-> @touch-variables :options
                                                    :reset-position-on-swipe-direction-change?)
        on-handle-touch (-> @touch-variables :options :on-handle-touch)
        on-tap (-> @touch-variables :options :on-tap)
        start-y (-> @touch-variables :start :y)
        move-y (-> @touch-variables :move :y)
        prev-move-y (-> @touch-variables :prev-move :y)
        previous-swipe-direction (-> @touch-variables :handler :current-swipe-direction-y)
        current-swipe-direction (> move-y prev-move-y)
        relative-y (when move-y (- move-y start-y))         ;;Negative upward, positive downward
        prev-relative-y (when prev-move-y (- prev-move-y start-y))
        start-time (-> @touch-variables :start :time)
        end-time (-> @touch-variables :end :time)
        move-time (-> @touch-variables :move :time)
        prev-move-time (-> @touch-variables :prev-move :time)
        swipe-duration (when (and start-time end-time) (- end-time start-time))
        last-swipe-duration (when (and prev-move-time move-time) (- prev-move-time move-time))
        velocity-y (when last-swipe-duration (/ (- relative-y prev-relative-y) last-swipe-duration))
        viewport-height (or (-> @touch-variables :options :viewport-height)
                          (-> @touch-variables :handler :viewport-height)
                          (. js/window -innerHeight)
                          (. (. js/document -documentElement) -clientHeight)
                          (. (. js/document -body) -clientHeight))
        normalized-relative-y (/ relative-y viewport-height)
        normalized-velocity-y (/ velocity-y viewport-height)
        scaled-normalized-relative-y (if (> normalized-relative-y 0)
                                       (- normalized-relative-y (Math/floor normalized-relative-y))
                                       (- normalized-relative-y (Math/ceil normalized-relative-y)))
        prev-scaled-normalized-relative-y (-> @touch-variables :handler :scaled-normalized-relative-y)
        handler {:previous-swipe-direction-y previous-swipe-direction
                 :current-swipe-direction-y current-swipe-direction
                 :previous-relative-y prev-relative-y
                 :relative-y relative-y
                 :swipe-duration swipe-duration
                 :last-swipe-duration last-swipe-duration
                 :velocity-y velocity-y
                 :viewport-height viewport-height
                 :normalized-relative-y normalized-relative-y
                 :normalized-velocity-y normalized-velocity-y
                 :scaled-normalized-relative-y scaled-normalized-relative-y
                 :prev-scaled-normalized-relative-y prev-scaled-normalized-relative-y}]
    ;; When changing swipe direction, we set the new start position
    (when (and (not (false? reset-position-on-swipe-direction-change?))
            (not (nil? previous-swipe-direction))
            (not (= previous-swipe-direction current-swipe-direction)))
      (swap! touch-variables #(assoc-in % [:start :y] move-y)))

    (swap! touch-variables assoc :handler handler)
    (if (and on-tap
          swipe-duration
          (< swipe-duration min-time-threshold)
          (< (Math/abs relative-y) min-distance-threshold))
      (on-tap @touch-variables)
      (when (fn? on-handle-touch)
        (on-handle-touch @touch-variables)))
    
    (when (and end-time swipe-decay-active?)
      (swipe-vertical-decay))))

(defn swipe-decay []
  (let [swipe-decay-amount (-> @touch-variables :options :swipe-decay-amount)
        swipe-horizontal? (-> @touch-variables :options :swipe-horizontal?)
        swipe-vertical? (-> @touch-variables :options :swipe-vertical?)
        on-handle-swipe-decay (-> @touch-variables :options :on-handle-swipe-decay)
        normalized-relative-x (when swipe-horizontal? (-> @touch-variables :handler :normalized-relative-x))
        normalized-relative-y (when swipe-vertical? (-> @touch-variables :handler :normalized-relative-y))
        normalized-velocity-x (when swipe-horizontal? (* swipe-decay-amount (-> @touch-variables :handler
                                                                              :normalized-velocity-x)))
        normalized-velocity-y (when swipe-vertical? (* swipe-decay-amount (-> @touch-variables :handler
                                                                            :normalized-velocity-y)))
        normalized-swipe-velocity (when (and (not swipe-horizontal?) (not swipe-vertical?))
                                    (* swipe-decay-amount (-> @touch-variables :handler
                                                            :normalized-swipe-velocity)))
        normalized-relative-radius (when (and (not swipe-horizontal?) (not swipe-vertical?))
                                     (-> @touch-variables :handler :normalized-relative-radius))
        updated-normalized-relative-x (when swipe-horizontal? (+ normalized-relative-x normalized-velocity-x))
        updated-normalized-relative-y (when swipe-vertical? (+ normalized-relative-y normalized-velocity-y))
        updated-normalized-relative-radius (when (and (not swipe-horizontal?) (not swipe-vertical?))
                                             (+ normalized-relative-radius normalized-swipe-velocity))
        updated-swipe-decay {:normalized-relative-x updated-normalized-relative-x
                             :normalized-relative-y updated-normalized-relative-y
                             :normalized-relative-radius updated-normalized-relative-radius}]
    (swap! touch-variables assoc :swipe-decay updated-swipe-decay)
    (when (fn? on-handle-swipe-decay)
      (on-handle-swipe-decay @touch-variables))))

(defn handle-simple-touch []
  (let [start-x (-> @touch-variables :start :x)
        move-x (or (-> @touch-variables :move :x) start-x)
        prev-move-x (or (-> @touch-variables :prev-move :x) start-x)
        start-y (-> @touch-variables :start :y)
        move-y (or (-> @touch-variables :move :y) start-y)
        prev-move-y (or (-> @touch-variables :prev-move :y) start-y)]
    (when (or (> (Math/abs (- prev-move-x move-x)) 1) (> (Math/abs (- prev-move-y move-y)) 1))
      (let [min-distance-threshold (-> @touch-variables :options :min-distance-threshold)
            min-time-threshold (-> @touch-variables :options :min-time-threshold)
            swipe-horizontal? (-> @touch-variables :options :swipe-horizontal?)
            swipe-vertical? (-> @touch-variables :options :swipe-vertical?)
            reset-position-on-swipe-direction-change? (-> @touch-variables :options
                                                        :reset-position-on-swipe-direction-change?)
            on-handle-touch (-> @touch-variables :options :on-handle-touch)
            on-tap (-> @touch-variables :options :on-tap)
            start-x (-> @touch-variables :start :x)
            start-y (-> @touch-variables :start :y)
            move-x (-> @touch-variables :move :x)
            move-y (-> @touch-variables :move :y)
            prev-move-x (-> @touch-variables :prev-move :x)
            prev-move-y (-> @touch-variables :prev-move :y)
            previous-swipe-direction-x (-> @touch-variables :handler :current-swipe-direction)
            current-swipe-direction-x (> move-x prev-move-x)
            previous-swipe-direction-y (-> @touch-variables :handler :current-swipe-direction)
            current-swipe-direction-y (> move-x prev-move-y)
            relative-x (when (and swipe-horizontal? move-x) (- move-x start-x)) ;;Negative to the left, positive to the right
            relative-y (when (and swipe-vertical? move-y) (- move-y start-y)) ;;Negative upward, positive downward
            relative-radius (when (and (not swipe-vertical?) (not swipe-horizontal?))
                              (Math/sqrt (* relative-x relative-x) (* relative-y relative-y)))
            start-time (-> @touch-variables :start :time)
            end-time (-> @touch-variables :end :time)
            move-time (-> @touch-variables :move :time)
            prev-move-time (-> @touch-variables :prev-move :time)
            swipe-duration (when (and start-time end-time) (- end-time start-time))
            last-swipe-duration (when (and prev-move-time move-time) (- prev-move-time move-time))
            handler {:previous-swipe-direction-x previous-swipe-direction-x
                     :current-swipe-direction-x current-swipe-direction-x
                     :previous-swipe-direction-y previous-swipe-direction-y
                     :current-swipe-direction-y current-swipe-direction-y
                     :relative-x relative-x
                     :relative-y relative-y
                     :swipe-duration swipe-duration
                     :last-swipe-duration last-swipe-duration}]
        ;; When changing swipe direction, we set the new start position
        (when (and (not (false? reset-position-on-swipe-direction-change?))
                (not (nil? previous-swipe-direction-x))
                (not (= previous-swipe-direction-x current-swipe-direction-x)))
          (swap! touch-variables #(assoc-in % [:start :x] move-x)))
        (when (and (not (false? reset-position-on-swipe-direction-change?))
                (not (nil? previous-swipe-direction-y))
                (not (= previous-swipe-direction-y current-swipe-direction-y)))
          (swap! touch-variables #(assoc-in % [:start :y] move-y)))

        (swap! touch-variables assoc :handler handler)
        (if (and (fn? on-tap)
              swipe-duration
              (< swipe-duration min-time-threshold)
              (< (or (Math/abs relative-x) (Math/abs relative-y) relative-radius) min-distance-threshold))
          (on-tap @touch-variables)
          (when (fn? on-handle-touch)
            (on-handle-touch @touch-variables)))))))

(defn handle-touch []
  (let [min-distance-threshold (-> @touch-variables :options :min-distance-threshold)
        min-time-threshold (-> @touch-variables :options :min-time-threshold)
        swipe-decay-active? (-> @touch-variables :options :swipe-decay-active?)
        swipe-horizontal? (-> @touch-variables :options :swipe-horizontal?)
        swipe-vertical? (-> @touch-variables :options :swipe-vertical?)
        reset-position-on-swipe-direction-change? (-> @touch-variables :options
                                                    :reset-position-on-swipe-direction-change?)
        on-handle-touch (-> @touch-variables :options :on-handle-touch)
        on-tap (-> @touch-variables :options :on-tap)
        start-x (-> @touch-variables :start :x)
        start-y (-> @touch-variables :start :y)
        move-x (-> @touch-variables :move :x)
        move-y (-> @touch-variables :move :y)
        prev-move-x (-> @touch-variables :prev-move :x)
        prev-move-y (-> @touch-variables :prev-move :y)
        previous-swipe-direction-x (-> @touch-variables :handler :current-swipe-direction)
        current-swipe-direction-x (> move-x prev-move-x)
        previous-swipe-direction-y (-> @touch-variables :handler :current-swipe-direction)
        current-swipe-direction-y (> move-x prev-move-y)
        relative-x (when (and swipe-horizontal? move-x) (- move-x start-x)) ;;Negative to the left, positive to the right
        relative-y (when (and swipe-vertical? move-y) (- move-y start-y)) ;;Negative upward, positive downward
        prev-relative-x (when (and swipe-horizontal? prev-move-x) (- prev-move-x start-x))
        prev-relative-y (when (and swipe-vertical? prev-move-y) (- prev-move-y start-y))
        relative-radius (when (and (not swipe-vertical?) (not swipe-horizontal?))
                          (Math/sqrt (* relative-x relative-x) (* relative-y relative-y)))
        start-time (-> @touch-variables :start :time)
        end-time (-> @touch-variables :end :time)
        move-time (-> @touch-variables :move :time)
        prev-move-time (-> @touch-variables :prev-move :time)
        swipe-duration (when (and start-time end-time) (- end-time start-time))
        last-swipe-duration (when (and prev-move-time move-time) (- prev-move-time move-time))
        velocity-x (when (and swipe-horizontal? last-swipe-duration) (/ (- relative-x prev-relative-x) last-swipe-duration))
        velocity-y (when (and swipe-vertical? last-swipe-duration) (/ (- relative-y prev-relative-y) last-swipe-duration))
        viewport-width (or (-> @touch-variables :options :viewport-width)
                         (-> @touch-variables :handler :viewport-width)
                         (. js/window -innerWidth)
                         (. (. js/document -documentElement) -clientWidth)
                         (. (. js/document -body) -clientWidth))
        viewport-height (or (-> @touch-variables :options :viewport-height)
                          (-> @touch-variables :handler :viewport-height)
                          (. js/window -innerHeight)
                          (. (. js/document -documentElement) -clientHeight)
                          (. (. js/document -body) -clientHeight))
        normalized-relative-x (when swipe-horizontal? (/ relative-x viewport-width))
        normalized-relative-y (when swipe-vertical? (/ relative-y viewport-height))
        normalized-relative-radius (when relative-radius
                                     (Math/sqrt (* normalized-relative-x normalized-relative-x)
                                       (* normalized-relative-y normalized-relative-y)))
        normalized-prev-relative-x (when swipe-horizontal? (/ prev-relative-x viewport-width))
        normalized-prev-relative-y (when swipe-vertical? (/ prev-relative-y viewport-height))
        normalized-relative-move-radius (when relative-radius
                                          (Math/sqrt (* (- normalized-prev-relative-x normalized-relative-x) (- normalized-prev-relative-x normalized-relative-x))
                                            (* (- normalized-prev-relative-y normalized-relative-y) (- normalized-prev-relative-y normalized-relative-y))))
        normalized-velocity-x (when swipe-horizontal? (/ velocity-x viewport-width))
        normalized-velocity-y (when swipe-vertical? (/ velocity-y viewport-height))
        normalized-swipe-velocity (when (and relative-radius last-swipe-duration)
                                    (/ normalized-relative-move-radius last-swipe-duration))
        scaled-normalized-relative-x (if (> normalized-relative-x 0)
                                       (- normalized-relative-x (Math/floor normalized-velocity-x))
                                       (- normalized-velocity-x (Math/ceil normalized-velocity-x)))
        scaled-normalized-relative-y (if (> normalized-relative-y 0)
                                       (- normalized-relative-y (Math/floor normalized-relative-y))
                                       (- normalized-relative-y (Math/ceil normalized-relative-y)))
        scaled-normalized-relative-radius (- relative-radius (Math/floor relative-radius))
        prev-scaled-normalized-relative-x (-> @touch-variables :handler :scaled-normalized-relative-x)
        prev-scaled-normalized-relative-y (-> @touch-variables :handler :scaled-normalized-relative-y)
        handler {:previous-swipe-direction-x previous-swipe-direction-x
                 :current-swipe-direction-x current-swipe-direction-x
                 :previous-swipe-direction-y previous-swipe-direction-y
                 :current-swipe-direction-y current-swipe-direction-y
                 :previous-relative-x prev-relative-x
                 :relative-x relative-x
                 :previous-relative-y prev-relative-y
                 :relative-y relative-y
                 :swipe-duration swipe-duration
                 :last-swipe-duration last-swipe-duration
                 :velocity-x velocity-x
                 :velocity-y velocity-y
                 :relative-radius relative-radius
                 :viewport-width viewport-width
                 :viewport-height viewport-height
                 :normalized-relative-x normalized-relative-x
                 :normalized-relative-y normalized-relative-y
                 :normalized-relative-radius normalized-relative-radius
                 :normalized-relative-move-radius normalized-relative-move-radius
                 :normalized-velocity-x normalized-velocity-x
                 :normalized-velocity-y normalized-velocity-y
                 :normalized-swipe-velocity normalized-swipe-velocity
                 :scaled-normalized-relative-x scaled-normalized-relative-x
                 :scaled-normalized-relative-y scaled-normalized-relative-y
                 :scaled-normalized-relative-radius scaled-normalized-relative-radius
                 :prev-scaled-normalized-relative-x prev-scaled-normalized-relative-x
                 :prev-scaled-normalized-relative-y prev-scaled-normalized-relative-y}]
    ;; When changing swipe direction, we set the new start position
    (when (and (not (false? reset-position-on-swipe-direction-change?))
            (not (nil? previous-swipe-direction-x))
            (not (= previous-swipe-direction-x current-swipe-direction-x)))
      (swap! touch-variables #(assoc-in % [:start :x] move-x)))
    (when (and (not (false? reset-position-on-swipe-direction-change?))
            (not (nil? previous-swipe-direction-y))
            (not (= previous-swipe-direction-y current-swipe-direction-y)))
      (swap! touch-variables #(assoc-in % [:start :y] move-y)))

    (swap! touch-variables assoc :handler handler)
    (if (and (fn? on-tap)
          swipe-duration
          (< swipe-duration min-time-threshold)
          (< (or (Math/abs relative-x) (Math/abs relative-y) relative-radius) min-distance-threshold))
      (on-tap @touch-variables)
      (when (fn? on-handle-touch)
        (on-handle-touch @touch-variables)))
    
    (when (and end-time swipe-decay-active?)
      (swipe-decay))))

;; Todo: Add multi touch support. Only using the first touch atm. So no multi finger pan, swipe etc.
;; Only need to prevent default on touch-start. Doing it on every other event leads to errors and warnigns from react:
;; [Intervention] Ignored attempt to cancel a touchmove/touchend/touchcancel event with cancelable=false, for example
;; because scrolling is in progress and cannot be interrupted.
(let [timeouts (atom {})]
  (fn [{:keys [id callback ms action]}]
    (let [existing (get @timeouts id)]
      (if (and (contains? #{:start :set :begin} action) (not existing))
        (when (fn? callback)
          (swap! timeouts assoc id (js/setTimeout callback ms)))
        (when existing
          (js/clearTimeout existing)
          (swap! timeouts dissoc id))))))

(defonce touch-timeouts (atom {}))

(defn start [event & [touch-options on-touch-start]]
  (let [options (merge
                  {:min-distance-threshold 35          ;;required min distance traveled to be considered swipe
                   :min-time-threshold     250         ;;required min time to be considered swipe
                   :swipe-decay-amount     1000        ;;how long the last swipe move
                   :max-touch-duration     5000}       ;;How long a touch can last for until it is freed.
                  touch-options)
        is-mouse? (s/includes? (. event -type) "mouse")
        touch-start (if is-mouse?
                      {:x (. event -pageX)
                       :y (. event -pageY)
                       :time (. event -timeStamp)}
                      (let [touches (. event -touches)]
                        {:number-of-touches (. touches -length)
                         :x (. (aget touches 0) -pageX)
                         :y (. (aget touches 0) -pageY)
                         :force (. (aget touches 0) -force)
                         :radius-x (. (aget touches 0) -radiusX)
                         :radius-y (. (aget touches 0) -radiusY)
                         :rotation-angle (. (aget touches 0) -rotationAngle)
                         :time (. event -timeStamp)}))
        previous-touch-id (:previous-touch-id @touch-variables)]
    (when (:prevent-default? options)
      (.preventDefault event))
    (.stopPropagation event)
    (reset! touch-variables
      {:start touch-start
       :options options
       :active? true
       :state :start
       :current-touch-id (. event -timeStamp)})
    (when-let [existing-timeout (get @touch-timeouts previous-touch-id)]
      (js/clearTimeout existing-timeout))
    (reset! touch-timeouts
      {(. event -timeStamp) 
       (js/setTimeout
             (fn []
               (when (= (:state @touch-variables) :move)
                 (reset! touch-variables
                   {:timed-out? true
                    :state :timed-out
                    :previous-touch-id (. event -timeStamp)})))
             (:max-touch-duration options))})
    (when (fn? on-touch-start)
      (on-touch-start @touch-variables))))

(defn move [event & [on-touch-move]]
  (when (-> @touch-variables :active?)
    (let [is-mouse? (s/includes? (. event -type) "mouse")
          touch-move (if is-mouse?
                       {:x (. event -pageX)
                        :y (. event -pageY)
                        :time (. event -timeStamp)}
                       (let [touches (. event -touches)]
                         {:number-of-touches (. touches -length)
                          :x (. (aget touches 0) -pageX)
                          :y (. (aget touches 0) -pageY)
                          :time (. event -timeStamp)}))
          swipe-horizontal? (-> @touch-variables :options :swipe-horizontal?)
          swipe-vertical? (-> @touch-variables :options :swipe-vertical?)
          simple-swipe? (-> @touch-variables :options :simple-swipe?)
          first-call? (nil? (-> @touch-variables :prev-move))
          prev-touch-move (-> @touch-variables :move)]
      (when first-call?
        (when (-> @touch-variables :options :prevent-default?)
          (.preventDefault event))
        (.stopPropagation event))
      (swap! touch-variables assoc
        :move touch-move
        :prev-move prev-touch-move
        :state :move)
      (when-not (:timed-out? @touch-variables)
        (cond
          (and swipe-horizontal? simple-swipe?)
          (handle-simple-horizontal-touch)
          (and swipe-vertical? simple-swipe?)
          (handle-simple-vertical-touch)
          swipe-horizontal?
          (handle-horizontal-touch)
          swipe-vertical?
          (handle-vertical-touch)
          simple-swipe?
          (handle-simple-touch)
          :else
          (handle-touch)))
      (when (and (not (:timed-out? @touch-variables)) (fn? on-touch-move))
        (on-touch-move @touch-variables)))))

(defn end [event & [on-touch-end]]
  (when (-> @touch-variables :active?)
    (let [is-mouse? (s/includes? (. event -type) "mouse")
          touch-end (if is-mouse?
                      {:time (. event -timeStamp)}
                      {:number-of-touches (.. event -touches -length)
                       :time (. event -timeStamp)})
          swipe-horizontal? (-> @touch-variables :options :swipe-horizontal?)
          swipe-vertical? (-> @touch-variables :options :swipe-vertical?)
          current-touch-id (:current-touch-id @touch-variables)]
      (swap! touch-variables assoc
        :end touch-end
        :active? false
        :state :end
        :previous-touch-id current-touch-id)
      (cond
        swipe-horizontal?
        (handle-horizontal-touch)
        swipe-vertical?
        (handle-vertical-touch)
        :else
        (handle-touch))
      (when (fn? on-touch-end)
        (on-touch-end @touch-variables)))))


;; This does not seem to work or trigger at all
(defn cancel [event & [on-touch-cancel]]
  (when (-> @touch-variables :active?)
    (let [is-mouse? (s/includes? (. event -type) "mouse")
          touch-cancel (if is-mouse?
                         {:x (. event -pageX)
                          :y (. event -pageY)
                          :time (. event -timeStamp)}
                         (let [touches (. event -touches)]
                           {:number-of-touches (. touches -length)
                            :x (. (aget touches 0) -pageX)
                            :y (. (aget touches 0) -pageY)
                            :time (. event -timeStamp)}))
          swipe-horizontal? (-> @touch-variables :options :swipe-horizontal?)
          swipe-vertical? (-> @touch-variables :options :swipe-vertical?)
          current-touch-id (:current-touch-id @touch-variables)]
      (swap! touch-variables assoc
        :cancel touch-cancel
        :active? false
        :state :cancel
        :previous-touch-id current-touch-id)
      (cond
        swipe-horizontal?
        (handle-horizontal-touch)
        swipe-vertical?
        (handle-vertical-touch)
        :else
        (handle-touch))
      (when (fn? on-touch-cancel)
        (on-touch-cancel @touch-variables)))))